import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createDirectSignup,
  DirectSignupState,
  resetDirectSignupState,
  selectDirectSignup,
  selectDirectSignupState,
} from './directSignupSlice';
import { SignupError } from '../../components/registration/SignupError/SignupError';
import { LoadingScreen } from '../../components/shared/LoadingScreen/LoadingScreen';
import { SignupSuccess } from '../../components/registration/SignupSuccess/SignupSuccess';
import { HAT_DOMAIN } from '../../app.config';
import { selectSandbox } from '../sandbox/sandboxSlice';

type Props = {
  children: React.ReactNode;
};

export const DirectSignupProcess: React.FC<Props> = (props) => {
  const sandbox = useSelector(selectSandbox); //IS_APP_SANDBOX;
  const state = useSelector(selectDirectSignup);
  const signupState = useSelector(selectDirectSignupState);
  const dispatch = useDispatch();

  const hatDomain = () => {
    if (HAT_DOMAIN?.includes('dataswift.net')) {
      return HAT_DOMAIN;
    } else {
      return sandbox ? '.hubat.net' : '.hubofallthings.net';
    }
  };

  useEffect(() => {
    if (signupState === DirectSignupState.processing) {
      dispatch(createDirectSignup(Object.assign({}, state), sandbox));
    }

    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, [signupState]);

  useEffect(() => {
    return () => {
      dispatch(resetDirectSignupState());
    };
  }, [dispatch]);

  switch (signupState) {
    case DirectSignupState.idle:
      return <>{props.children}</>;
    case DirectSignupState.failed:
      return <SignupError sandbox={sandbox} />;
    case DirectSignupState.processing:
      return <LoadingScreen messageId={'hatters.signup.pdaBeingCreated'} />;
    case DirectSignupState.successful:
      return <SignupSuccess hatDomain={state.username + hatDomain()} nextStep={state.nextStep} />;
  }
};
